export const SEQUENCE = 1;
export const PRESET = 2;
export const GUILD_KEY = 3;
export const SOUND= 4;
